/* Build Your Set - gown picker + rail (the "Comfort at the best prices" segment).
   Standalone like extras.js: uses window.BYS money/esc helpers when present,
   announces cart changes via 'cart:updated' and listens for the same event so
   the set builder's adds keep this rail honest. All hooks are data-gp-*.
   The ladder here is display only; the parked automatic discounts are the money. */
(function () {

  function init(root) {
    if (root.getAttribute('data-gp-ready') === '1') return;
    root.setAttribute('data-gp-ready', '1');
    var BYS = window.BYS || {};
    var money = BYS.money || function (c) { return '$' + (c / 100).toFixed(2); };
    var esc = BYS.esc || function (s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); };

    var styleSel = root.querySelector('[data-gp-style]');
    var optsEl = root.querySelector('[data-gp-options]');
    var mediaEl = root.querySelector('[data-gp-media]');
    var priceTag = root.querySelector('[data-gp-pricetag]');
    var stateEl = root.querySelector('[data-gp-state]');
    var slotsEl = root.querySelector('[data-gp-slots]');
    var fullEl = root.querySelector('[data-gp-fullprice]');
    var payEl = root.querySelector('[data-gp-payprice]');
    var noteEl = root.querySelector('[data-gp-savenote]');
    var addBtn = root.querySelector('[data-gp-add]');
    var addedEl = root.querySelector('[data-gp-added]');
    var errEl = root.querySelector('[data-gp-error]');
    var tiersEl = root.querySelector('[data-gp-tiers]');
    var progEl = root.querySelector('[data-gp-prog]');
    var mileEl = root.querySelector('[data-gp-mile]');
    if (!styleSel || !optsEl || !addBtn) return;

    var addLabel = addBtn.textContent;
    var trim = root.getAttribute('data-gp-trim') || '';
    var swatchMaps = {};
    try { swatchMaps = JSON.parse((root.querySelector('[data-gp-swatches]') || {}).textContent || '{}'); } catch (e) {}

    var handles = [].slice.call(styleSel.options).map(function (o) { return o.value; }).filter(Boolean);
    var tiers = tiersEl ? [].slice.call(tiersEl.children).map(function (el) {
      return { el: el, q: parseInt(el.getAttribute('data-q'), 10) || 0, amt: (parseInt(el.getAttribute('data-amt'), 10) || 0) * 100 };
    }).filter(function (t) { return t.q > 0; }) : [];
    var maxQ = tiers.length ? tiers[tiers.length - 1].q : 0;

    var product = null, sel = [], cache = {};
    var cartLines = [], cartCount = 0;

    function trimName(t) {
      t = String(t || '');
      if (trim && t.indexOf(trim + ' ') === 0) { var r = t.slice(trim.length).replace(/^\s+/, ''); if (r) return r; }
      return t;
    }
    function match() {
      if (!product) return null;
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i], ok = true;
        for (var j = 0; j < sel.length; j++) { if (v.options[j] !== sel[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function tierAmt(n) {
      var a = 0;
      tiers.forEach(function (t) { if (t.q <= n) a = t.amt; });
      return a;
    }
    function thumb(src) {
      return String(src).replace(/(\.[a-z]+)(\?|$)/i, '_160x160_crop_center$1$2');
    }
    /* Compare-at aware price. Sandra's permanent 30% DayBasics markdown sets
       compare_at_price on every variant, so this lights up on its own the moment
       the Matrixify reprice lands; before that it renders the plain price. */
    function priceHTML(v) {
      if (!v) return '';
      var was = v.compare_at_price || 0;
      return (was > v.price ? '<s>' + money(was) + '</s> ' : '') + money(v.price);
    }

    function paintOptions() {
      var swatches = (product && swatchMaps[product.handle]) || {};
      var html = '';
      var names = (product.options || []).map(function (o) { return (o && o.name) ? o.name : o; });
      names.forEach(function (name, i) {
        var values = [];
        product.variants.forEach(function (v) { if (values.indexOf(v.options[i]) < 0) values.push(v.options[i]); });
        var isColor = /colou?r/i.test(String(name));
        html += '<div class="bys__gopt-l">' + esc(name) + ' &middot; <b>' + esc(sel[i] || '') + '</b></div>';
        html += '<div class="bys__qa-row" data-gp-i="' + i + '">';
        values.forEach(function (val) {
          var avail = product.variants.some(function (v) { return v.options[i] === val && v.available; });
          var state = (sel[i] === val ? ' aria-pressed="true"' : '') + (avail ? '' : ' disabled');
          var hex = isColor ? swatches[val] : null;
          if (hex) {
            html += '<button type="button" class="bys__qa-sw" data-gp-val="' + esc(val) + '" style="--sw:' + esc(hex) + '"' +
              ' title="' + esc(val) + '" aria-label="' + esc(val) + '"' + state + '></button>';
          } else {
            html += '<button type="button" class="bys__qa-pill" data-gp-val="' + esc(val) + '"' + state + '>' + esc(val) + '</button>';
          }
        });
        html += '</div>';
      });
      optsEl.innerHTML = html;
      [].slice.call(optsEl.querySelectorAll('.bys__qa-pill, .bys__qa-sw')).forEach(function (p) {
        p.addEventListener('click', function () {
          var i = parseInt(p.parentNode.getAttribute('data-gp-i'), 10);
          sel[i] = p.getAttribute('data-gp-val');
          paintOptions(); paintMedia(); paintRail();
        });
      });
    }

    function paintMedia() {
      if (!product) return;
      var m = match();
      var img = (m && m.featured_image && m.featured_image.src) || product.featured_image;
      var v = m || product.variants[0];
      if (img && mediaEl) {
        var badge = mediaEl.querySelector('.bys__cardbadge');
        mediaEl.innerHTML = (badge ? badge.outerHTML : '') +
          '<img src="' + esc(img) + '" alt="' + esc(product.title) + '" width="800" height="1000" loading="lazy">' +
          '<span class="bys__gpricetag">' + priceHTML(v) + '</span>';
        priceTag = mediaEl.querySelector('.bys__gpricetag');
      } else if (priceTag && v) {
        priceTag.innerHTML = priceHTML(v);
      }
    }

    function paintRail() {
      var m = match();
      var live = m && m.available;
      var withPick = cartCount + (live ? 1 : 0);

      var html = '';
      cartLines.forEach(function (it) {
        html += '<div class="bys__slot is-filled">' +
          '<span class="bys__slot-thumb">' + (it.image ? '<img src="' + esc(thumb(it.image)) + '" alt="" width="54" height="54" loading="lazy">' : '') + '</span>' +
          '<span class="bys__slot-t"><b>' + esc(trimName(it.product_title)) + '</b>' +
          '<span>' + esc(it.variant_title || '') + ' &middot; ' +
          (it.original_price > it.price ? '<s>' + money(it.original_price) + '</s> ' : '') + money(it.price) +
          (it.quantity > 1 ? ' &times; ' + it.quantity : '') + '</span></span>' +
          '<span class="bys__gtag">In cart</span></div>';
      });
      if (product && m) {
        var pimg = (m.featured_image && m.featured_image.src) || product.featured_image;
        html += '<div class="bys__slot is-filled">' +
          '<span class="bys__slot-thumb">' + (pimg ? '<img src="' + esc(thumb(pimg)) + '" alt="" width="54" height="54" loading="lazy">' : '') + '</span>' +
          '<span class="bys__slot-t"><b>' + esc(trimName(product.title)) + '</b>' +
          '<span>' + (m.options || []).map(esc).join(' &middot; ') + ' &middot; ' + priceHTML(m) + '</span></span>' +
          '<span class="bys__gtag bys__gtag--pick">Your pick</span></div>';
      }
      slotsEl.innerHTML = html;

      var cartTotal = 0, cartWas = 0;
      cartLines.forEach(function (it) {
        cartTotal += it.price * it.quantity;
        cartWas += (it.original_price > it.price ? it.original_price : it.price) * it.quantity;
      });
      var full = cartTotal + (live ? m.price : 0);
      var mWas = live ? ((m.compare_at_price || 0) > m.price ? m.compare_at_price : m.price) : 0;
      var wasTotal = cartWas + mWas;
      var disc = tierAmt(withPick);

      if (withPick === 0) {
        fullEl.hidden = true;
        payEl.textContent = 'Pick your gown';
        noteEl.textContent = '';
      } else {
        var gpay = full - disc;
        if (wasTotal > gpay) {
          fullEl.hidden = false;
          fullEl.textContent = money(wasTotal);
        } else {
          fullEl.hidden = true;
        }
        payEl.textContent = money(gpay);
        if (live && withPick >= 2 && disc > tierAmt(cartCount)) {
          noteEl.innerHTML = 'Add it and you unlock <b>' + money(disc) + ' off, automatically.</b>';
        } else if (live && withPick === 1) {
          var t2 = tiers.length ? tiers[0] : null;
          noteEl.innerHTML = t2 ? 'Add a second gown to unlock <b>' + money(t2.amt) + ' off.</b>' : '';
        } else if (disc > 0) {
          noteEl.innerHTML = 'You are saving <b>' + money(disc) + '</b>, automatically.';
        } else {
          noteEl.textContent = '';
        }
      }

      addBtn.disabled = !live;
      addBtn.textContent = live ? addLabel + ' · ' + money(m.price) : (product ? 'That combination is sold out' : addLabel);

      if (stateEl) {
        if (cartCount === 0 && !live) stateEl.textContent = 'Pick a gown to start.';
        else if (cartCount === 0) stateEl.textContent = 'Nightgown savings start at two.';
        else stateEl.textContent = cartCount + (cartCount === 1 ? ' gown' : ' gowns') + ' in your cart' + (live ? ', one picked.' : '.');
      }

      tiers.forEach(function (t) {
        t.el.classList.remove('is-won', 'is-next', 'is-far');
        if (t.q <= cartCount) t.el.classList.add('is-won');
        else if (t.q <= withPick) t.el.classList.add('is-next');
        else if (t.q > withPick + 1) t.el.classList.add('is-far');
      });
      if (progEl && maxQ) progEl.style.width = Math.min(100, Math.round(withPick / maxQ * 100)) + '%';
      if (mileEl) {
        var next = null;
        for (var i = 0; i < tiers.length; i++) { if (tiers[i].q > withPick) { next = tiers[i]; break; } }
        if (withPick === 0) mileEl.textContent = 'Savings start at two gowns.';
        else if (next) {
          var need = next.q - withPick;
          mileEl.innerHTML = (need === 1 ? 'One more gown' : need + ' more gowns') + ' makes it <b>' + money(next.amt) + ' off.</b>';
        } else {
          mileEl.innerHTML = 'Maximum saving unlocked: <b>' + money(tierAmt(withPick)) + ' off.</b>';
        }
      }
    }

    function refreshCart() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function (c) {
          cartLines = (c.items || []).filter(function (it) { return handles.indexOf(it.handle) > -1; });
          cartCount = 0;
          cartLines.forEach(function (it) { cartCount += it.quantity; });
          paintRail();
        })
        .catch(function () {});
    }

    function loadStyle(handle) {
      if (cache[handle]) {
        product = cache[handle];
        var f = null;
        for (var i = 0; i < product.variants.length; i++) { if (product.variants[i].available) { f = product.variants[i]; break; } }
        sel = ((f || product.variants[0]).options || []).slice();
        paintOptions(); paintMedia(); paintRail();
        return;
      }
      fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function (p) {
          cache[handle] = p;
          if (styleSel.value === handle) loadStyle(handle);
        })
        .catch(function () { if (errEl) { errEl.textContent = 'Could not load that style. Please try again.'; } });
    }

    styleSel.addEventListener('change', function () {
      if (errEl) errEl.textContent = '';
      if (styleSel.value) loadStyle(styleSel.value);
    });

    addBtn.addEventListener('click', function () {
      var m = match();
      if (!m || !m.available) return;
      addBtn.disabled = true;
      addBtn.textContent = 'Adding...';
      if (errEl) errEl.textContent = '';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: m.id, quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function () {
          if (typeof window.upcartRefreshCart === 'function') { try { window.upcartRefreshCart(); } catch (e) {} }
          document.dispatchEvent(new CustomEvent('cart:updated'));
          if (addedEl) {
            addedEl.classList.add('is-shown');
            setTimeout(function () { addedEl.classList.remove('is-shown'); }, 3500);
          }
          refreshCart();
          setTimeout(function () { paintRail(); }, 50);
        })
        .catch(function () {
          if (errEl) errEl.textContent = 'Could not add to cart. Please try again.';
          paintRail();
        });
    });

    document.addEventListener('cart:updated', refreshCart);

    if (handles.length) {
      styleSel.value = handles[0];
      loadStyle(handles[0]);
    }
    refreshCart();
  }

  function boot() {
    [].slice.call(document.querySelectorAll('[data-bys-gownpick]')).forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
